//Initialisation
(function ($) {
    /* Collapse menu */
    const navToggle = document.getElementById("menu-opener");
    const navLinks = document.querySelectorAll(".nav__link");


    navToggle.addEventListener("click", () => {
        document.body.classList.toggle("nav-open");
    });

    navLinks.forEach((link) => {
        link.addEventListener("click", () => {
            document.body.classList.remove("nav-open");
        });
    });

    /* Hamburger */
    const hamburger = document.querySelector(".hamburger");
    hamburger.addEventListener("click", function () {
        hamburger.classList.toggle("is-active");
    });

    /*scroll down/top button on page header*/
    $('.scroll-down').on('click', function () {
        var scrollOffset = $(this).offset().top - 30;
        $("html, body").animate({scrollTop: scrollOffset}, "slow");
    });


    if ($("ul").hasClass("fadein-bullets")) {
        $(window).scroll(function (e) {
            let scroll = $(window).scrollTop();
            let section_top_offset = $(".fadein-bullets").offset().top;
            let section_top_height = $(".fadein-bullets").outerHeight();
            let section_top = section_top_offset + section_top_height;
            let window_height = window.innerHeight;
            if ((scroll + window_height) > (section_top + 80) && !$(".fadein-bullets").hasClass("displayed")) {
                $(".fadein-bullets li").each(function (index) {
                    $(this).delay(400 * index).fadeIn("fast");
                })
                $(".fadein-bullets").addClass("displayed");
            }
        });
    }

    if ($(".wp-block-pullquote")) {
        $(window).scroll(function (e) {
            $(".wp-block-pullquote").each(function () {
                let scroll = $(window).scrollTop();
                let section_top_offset = $(this).offset().top;
                let section_top_height = $(this).outerHeight();
                let section_top = section_top_offset + section_top_height;
                let window_height = window.innerHeight;
                if ((scroll + window_height) > (section_top - 80) && !$(this).hasClass('show-bg')) {
                    $(this).addClass('show-bg');
                }
            })

        });
    }

    //NEWSLETTER MODAL

    if (Cookies.get('visitedCookie') != "visited") {
        setTimeout(function () {
            if (Cookies.get('visitedCookie') != "visited") {
                $("#newsletter-modal").addClass("noshow")
                $("#newsletter-modal").addClass("nod-block")
            }
        }, 45000);
    }
    $(".newsletter-show-form").on('click', function () {
        $(".newsletter-show-form").addClass("d-none");
        $(".modal-body .newsletter-modal-close").addClass("d-none");
        $("#newsletter-form").removeClass("d-none");
        $(".close-btn").removeClass("d-none");
    });

    $(".newsletter-modal-close").on('click', function () {
        $("#newsletter-modal").removeClass("show")
        $("#newsletter-modal").removeClass("d-block");
        Cookies.set('visitedCookie', 'visited', {expires: 2, path: '/'})
    });

    $(".btn-newsletter-activate").on('click', function () {
        Cookies.set('visitedCookie', 'visited', {expires: 2, path: '/'})
    });

    $(".newsletter-show-form").on('click', function () {
        Cookies.set('visitedCookie', 'visited', {expires: 2, path: '/'})
    });



    $(".btn-newsletter-activate").on('click', function (e) {
        e.preventDefault();
        $(".newsletter-show-form").addClass("d-none");
        $(".modal-body .newsletter-modal-close").addClass("d-none");
        $("#newsletter-form").removeClass("d-none");
        $(".close-btn").removeClass("d-none");
        $("#newsletter-modal").addClass("show")
        $("#newsletter-modal").addClass("d-block")
    });


    //restricted access
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('atlresunl') && urlParams.get('atlresunl') == 1) {
        Cookies.set('resourcesUnlocked', 'unlocked', {expires: 9999, path: '/'})
    }

    $(".resources-modal-close").on('click', function () {
        $("#resources-modal").removeClass("show")
        $("#resources-modal").removeClass("d-block")
    });

    if ($(".locked-btn")) {
        $(".locked-btn").on('click', function (e) {
            if (Cookies.get('resourcesUnlocked') != "unlocked") {
                e.preventDefault();
                $("#resources-modal").addClass("show");
                $("#resources-modal").addClass("d-block");
            }
        });
        if (Cookies.get('resourcesUnlocked') != "unlocked") {
            $(".locked-btn").attr("href","#")
        }

    }

    if (Cookies.get('resourcesUnlocked') != "unlocked") {
        if ($(".locked-content"))
            $(".locked-content").removeClass("d-none");
    }


})(jQuery);